import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/coach-discovery/")({
  staticData: { title: "Coach Discovery" },
  beforeLoad: () => {
    throw redirect({ to: "/coach-finder", replace: true });
  },
});
